/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SearchTermInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Input from 'DesignSystem/Input/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SearchTermInput({
  children,
  viewPath = "/DesignSystem/CreateNewProfessionalModal/Details/Office/Search/Content/Content/SearchTermInput",
  onChange
  
}) {
let searchTermValueData = fromData.useDataValue({ viewPath,
context: 'search',
path: 'term',
})
let searchTermChangeData = fromData.useDataChange({ viewPath,
context: 'search',
path: 'term',
})
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
  return (<React.Fragment
>
<Input
  viewPath={`${viewPath}/Input`}
 backgroundColor={dtColorsNeutral100}
 className="mousetrap"
 data="search.term"
 onChange={searchTermChangeData}
 value={searchTermValueData}
 width="90%"
 placeholder="Search for offices..."
 autoFocus={true}
 autoSelect={true}
 className="mousetrap"
/>
{children}
</React.Fragment>)
}